export default __webpack_public_path__ + "static/media/kitchen1.8883e9bb.jpg";